import "./DistrictAttendanceReport.css";
import React, { useState, useEffect, useRef } from "react";
import { format, isSameDay } from "date-fns";
import DatePicker from "react-datepicker";
import { sameDatesAttendanceForItmReport, differentDatesAttendanceForItm, userLoginDashboard, } from "../../../../services/dashboard";
import { handleSortByTimeDirectArray } from "../../../../utils/sortingOrderByTime";

const DistrictAttendanceReport = () => {
    const today = new Date();

    /* ---------- Core state ---------- */
    const [fromDate, setFromDate] = useState(today);
    const [toDate, setToDate] = useState(today);
    const [sameDayAttendance, setSameDayAttendance] = useState(null);   // original payload
    const itmDistrict = localStorage.getItem("districtName");
    const itmDistrictId = localStorage.getItem("districtId");
    const employeeUniqueId = localStorage.getItem('employeeUniqueIdLogin');


    const [differenceDayAttendace, setDifferenceDayAttendance] = useState();
    const [userData, setUSerData] = useState([]);
    const [startDate, setStartDate] = useState(today);
    /* ---------- Filter state ---------- */
    const [displayMode, setDisplayMode] = useState("all"); // all | present | absent | notInLocation
    const [filteredRecords, setFilteredRecords] = useState([]); // what the table renders
    const [filterLoading, setFilterLoading] = useState(false);
    const [filterError, setFilterError] = useState(null);
    const [filterTitle, setFilterTitle] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    /* ---------- Load original attendance (same day / range) ---------- */
    useEffect(() => {
        const fetchAttendance = async () => {
            if (!itmDistrictId || !fromDate || !toDate) return;
            setFilterLoading(true);
            try {
                const same = isSameDay(fromDate, toDate);
                if (same) {
                    const data = await sameDatesAttendanceForItmReport(itmDistrictId, fromDate, toDate);
                   // setSameDayAttendance(data);
                    setFilteredRecords(data?.records || []);
                    setDisplayMode("all");
                    setFilterTitle("");
                } else {

                    const data = await differentDatesAttendanceForItm(itmDistrictId, fromDate, toDate);
                    setDifferenceDayAttendance(data);
                    setSameDayAttendance(null);

                }
            } catch (e) {
                console.error(e);
            } finally {
                setFilterLoading(false);
            }
        };
        fetchAttendance();
    }, [fromDate, toDate, itmDistrictId]);
    const getUserDetails = async () => {
        const data = await userLoginDashboard(employeeUniqueId, startDate);
        setUSerData(data);

    }
    useEffect(() => {
        getUserDetails();
    }, [employeeUniqueId, startDate]); // Correct dependencies



    const handleRowClick = (rowDate) => {
        const clickedDate = new Date(rowDate); // assuming rowDate is ISO string or valid date
        setFromDate(clickedDate);
        setToDate(clickedDate);

    };


    /* ---------- Table rows ---------- */
    const renderRows = () => {
        if (filterLoading) return <tr><td colSpan={9} className="text-center">Loading…</td></tr>;
        if (filterError) return <tr><td colSpan={9} className="text-center text-danger">{filterError}</td></tr>;
        if (!filteredRecords.length) return <tr><td colSpan={9} className="text-center">No data</td></tr>;

        return filteredRecords.map((r, i) => (
            <tr key={i}>
                <td>{i + 1}</td>
                <td className="text-start">{r.employeeName ?? "-"}</td>
                <td>{r.designation ?? "-"}</td>
 <td>
        {r.isWorkLocation === true
            ? (r.workLocationName?.trim() || "-")
            : (r.godownName?.trim() || "-")}
    </td>                <td>{r.contactNumber ?? "-"}</td>
                <td>{r.attendanceStatus ?? "-"}</td>
                <td>{r.attendanceTime ?? "-"}</td>
                <td>
                    {r.attendanceStatus === "Present" && (!r.remarks || r.remarks === "")
                        ? "In the location"
                        : r.remarks && r.attendanceStatus === "Present"
                            ? "Not in the location"
                            : "-"}
                </td>
                <td>{r.remarks ?? "-"}</td>
                <td>
                    {r.selfieUrl ? (
                        <a
                            href={r.selfieUrl.startsWith("http") ? r.selfieUrl : `${process.env.REACT_APP_FILE_BASE_URL}/${r.selfieUrl}`}
                            target="_blank"
                            rel="noreferrer"
                        >
                            View
                        </a>
                    ) : "-"}
                </td>
            </tr>
        ));
    };

    return (
        <div className="itm-dashboard-page-repo">
            <div className="itm-new-dashboard-dash-repo">
                <div className="itm-current-month-date-dash-repo">
                    <h2>District Attendance Report</h2>
                </div>


                <div className="itm-dates-repo">
                    <div className="itm-container-part-repo"><div className="itm-districtitm">District Attendance - {itmDistrict}</div></div>
                    <div className="itm-container-part-repo">
                        <div className={`itm-floating-label-container-1-repo ${fromDate ? "filled" : ""}`}>
                            <DatePicker selected={fromDate} onChange={setFromDate} dateFormat="dd-MM-yyyy" maxDate={today} placeholderText=" " />
                            <label>From Date</label>
                        </div>
                    </div>
                    <div className="itm-container-part-repo">
                        <div className={`itm-floating-label-container-1-repo ${toDate ? "filled" : ""}`}>
                            <DatePicker selected={toDate} onChange={setToDate} dateFormat="dd-MM-yyyy" minDate={fromDate} maxDate={today} placeholderText=" " />
                            <label>To Date</label>
                        </div>
                    </div>
                </div>

                {/* ---------- SAME-DAY VIEW ---------- */}
                {isSameDay(fromDate, toDate) && (
                    <>
                        <div className="itm-current-month-dash-repo">
                            {/* <div className="select-date-text-dash">
                                <div className="month-text-dash">Employees count of the day</div>
                            </div> */}


                            {/* <div className="itm-content-data-for-month-dash">
                                <div
                                    className={`itm-present-days-dash ${displayMode === "present" ? "active" : ""}`}
                                    onClick={showPresent}
                                    style={{ cursor: "pointer" }}
                                >
                                    <div className="itm-data-user-values1">{sameDayAttendance?.presentCount ?? 0}</div>
                                    <div className="itm-data-user-label">No of Present</div>
                                </div>

                                <div
                                    className={`itm-present-days-dash ${displayMode === "absent" ? "active" : ""}`}
                                    onClick={showAbsent}
                                    style={{ cursor: "pointer" }}
                                >
                                    <div className="itm-data-user-values2">{sameDayAttendance?.absentCount ?? 0}</div>
                                    <div className="itm-data-user-label">No of Absent</div>
                                </div>

                                <div
                                    className={`itm-present-days-dash leave-card ${displayMode === "notInLocation" ? "active" : ""}`}
                                    onClick={showNotInLocation}
                                    style={{ cursor: "pointer" }}
                                >
                                    <div className="itm-data-user-values3">{sameDayAttendance?.remarksCount ?? 0}</div>
                                    <div className="itm-data-user-label">Not in the location</div>
                                </div>
                            </div> */}
                        </div>

                        {/* ----- Title + Show-All button ----- */}
                        {/* <div className="d-flex align-items-center justify-content-between mt-3 mb-2">
                            <h5 className="mb-0">{filterTitle || `All Employees – ${format(fromDate, "dd-MM-yyyy")}`}</h5>
                            {displayMode !== "all" && (
                                <button className="btn btn-sm btn-outline-primary" onClick={showAll}>
                                    Show All
                                </button>
                            )}
                        </div> */}

                        {/* ----- Table ----- */}
                        <div className="itm-table-for-emp-repo">
                            <table className="itm-table-dash-repo">
                                <thead className="itm-table-head-dash-repo">
                                    <tr>
                                        <th>S.No</th>
                                        <th>Employee Name</th>
                                        <th>Designation</th>
                                         <th>Working Location</th>
                                        <th>Mobile Number</th>
                                        <th>Attendance Status</th>
                                        <th
                                            onClick={() =>
                                                handleSortByTimeDirectArray(sortOrder, setSortOrder, filteredRecords, setFilteredRecords)
                                            }
                                            style={{ cursor: "pointer" }}
                                        >
                                            Attendance Time {sortOrder === "asc" ? "▲" : "▼"}
                                        </th>

                                        <th>Location Status</th>
                                        <th>Remarks</th>
                                        <th>Attendance Photo</th>
                                    </tr>
                                </thead>
                                <tbody className="table-body-dash">{renderRows()}</tbody>
                            </table>
                        </div>
                    </>
                )}

                {/* ---------- RANGE VIEW (unchanged) ---------- */}
                {!isSameDay(fromDate, toDate) && (
                    /* your existing range table – omitted for brevity */
                    <div className="border rounded-2 mt-5 thick-border">
                        <table className="mx-auto my-3">
                            <thead className="itm-table-head-dash-repo">
                                <tr >
                                    <th>S.No</th>
                                    <th>Date</th>
                                      <th>Total No. of Employees</th>
                                    <th>No. of Employees Present</th>
                                    <th>No. of Employees Absent</th>
                                    <th>No. of Employees on Leave</th>
                                    {/* <th>No. of Remarks</th> */}

                                </tr>
                            </thead>
                            <tbody className="table-body-dash " style={{ cursor: "pointer" }}>
                                {differenceDayAttendace?.length > 0 ? (
                                    differenceDayAttendace.map((record, index) => (
                                        <tr key={index} onClick={() => handleRowClick(record.date)}>
                                            <td>{index + 1}</td>
                                            <td>{format(record.date, 'dd-MM-yyyy') || "-"}</td>
                                             <td>{record.totalEmployeesCount}</td>
                                            <td>{record.presentCount || "-"}</td>
                                            <td>{record.absentCount || "-"}</td>
                                            <td>
                                                {record.leaveCount || "-"}
                                            </td>

                                            {/* <td>{record.remarksCount || "-"}</td> */}

                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: 'center', padding: '1rem' }}>
                                            {userData?.dailyRecords ? 'No attendance data available.' : 'Loading attendance data…'}
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DistrictAttendanceReport;